export class LaunchURLVO {
	public auth: string;
	public content_token: string;
	public externalRegistration: string;
	public externalConfiguration: string;
	public endpoint: string;
	public width: string;
	public height: string;
	public left: string;
	public top: string;
	public actor: any;
	public registration: string;
	public fetch: string;
	public grouping: string;
	public configDoc: string;
	public branding_profile: string;
	public activityId: string;
	public activity_id: string;
	public content_endpoint: string;
}
